// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components'

import Button from '../../../components/Button';
import LoadingIcon from '../../../components/LoadingIcon';
import Tooltip from '../NewSupportForm/TooltipImage';

const otherS = {
  // Full
  MessageFieldWrapper: styled.div`
    border-radius: 4px;
    margin-top: 12px;
    background: rgba(239, 239, 239, 0.5);
    flex-grow: 1;
    padding: 14px 23px 14px 18px;
    display: flex;
    flex-direction: column;
  `,
  Textarea: styled.textarea<{ inline?: boolean }>`
    flex: ${({ inline }) => inline ? '1 0 auto' : '1 1 0' };
    width: 100%;
    min-height: 81px;
    font-size: 16px;
    line-height: 23px;
    color: #434343;

    outline: none;
    border: none;
    resize: none;
    background: transparent;
    &::placeholder {
      color: #A6A6A6;
    }
  `,
  BottomWrapper: styled.div`
    margin-top: 26px;
    display: flex;
  `,
  ImageUploadWrapper: styled.div`
    /* padding-top: 40px; */
    padding-right: 10px;
    margin-right: 24px;
    display: flex;
    overflow-x: auto;
    align-items: flex-start;
  `,
  ImageContainer: styled.div`
   position: relative;
   margin-top: 14px;
   margin-right: 15px;
  `,
  ImageUploadItem: styled.img`
    flex-shrink: 0;
    width: 137px;
    height: 137px;
    object-fit: cover;
  `,
  CrossIcon: styled.img`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    width: 24px;
    height: 24px;
    cursor: pointer;
  `,
  ButtonWrapper: styled.div`
    flex-shrink: 0;
    margin-left: auto;
    align-self: flex-end;
    display: flex;
    align-items: center;
  `,
  ImageBtn: styled.img`
    cursor: pointer;
  `,
  TextCountWrapper: styled.div`
    margin-left: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  `,
  TextCount: styled.p`
    font-size: 12px;
    line-height: 20px;
    color: #848484;
    position: absolute;
    bottom: calc(100% + 4px);
  `,
  Btn: styled(Button) <{ disabled: boolean; isLoading?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 44px;
    box-shadow: 0px 3px 6px #00000029;
    font-size: 18px;
    line-height: 26px;
    background: #EF8200;
    color: #FFFFFF;

    cursor: ${({ disabled, isLoading }) => disabled || isLoading ? 'not-allowed' : 'pointer' };

    ${props => props.isLoading ? { opacity: 0.2 } : null }

    ${props => props.disabled && !props.isLoading ? `
      background: #EFEFEF;
      color: #C9C9C9;
    `: `
    `}

    &:disabled {
      ${props => props.isLoading ? { background: '#EF8200' } : null }
    }
  `,
  LoadingBtn: styled(Button)`
  `,
  LoadingIcon: styled(LoadingIcon)`
    padding: 0;
  `,
  FileInput: styled.input.attrs({ type: 'file', accept: 'image/*' })`
    display: none;
  `,
  Tooltip: styled(Tooltip)`
    align-self: auto;
    position: fixed;
    z-index: 10;
    pointer-events: none;
    transform: translate(-50%, -100%);
  `,
}

const S = {
  ...otherS,
  // Inline
  InlineWrapper: styled.div`
    border-radius: 4px;
    flex-grow: 0;
    margin-top: 12px;
    background: rgba(239, 239, 239, 0.5);
    padding: 10px 10px 8px 18px;
    display: flex;
    align-items: center;
    overflow: hidden;

    ${otherS.Textarea} {
      height: 1.5em;
      max-height: calc(16.5em + 0.5em); /* 11line + half line */
      min-height: revert;
    }

    ${otherS.Btn} {
      width: 60px;
      height: 32px;
      box-shadow: revert;
    }
  `,
  InlineMessageWrapper: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,
}

export { S as default };
